import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { PageMetaManager } from "./PageMeta";

export function AppRouter() {
  return (
    <>
      <RouterProvider router={router} />
      <PageMetaManager />
    </>
  );
}
